import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { EventOriginEnum, NavigateToEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { IRelatedAsset, RelatedAsset } from '@app/core/model/entities/asset/asset';
import { AssetsService } from '@app/features/main/views/assets/assets.service';
import { EntityFieldBuilder } from '@app/shared/components/fields/entity-field-builder/abstract-entity-field-builder';

@Component({
    selector: 'asset-field-builder',
    templateUrl: 'asset-field-builder.component.html',
    styleUrls: ['../entity-field-builder.component.scss'],
    standalone: false
})
export class AssetFieldBuilderComponent extends EntityFieldBuilder<IRelatedAsset, RelatedAsset> implements OnInit, AfterViewInit {
  protected assetsService = inject(AssetsService);

  /**
   * Instantiate a RelatedAsset
   * @param relatedAsset
   * @return RelatedAsset
   */
  public newRelatedEntity(relatedAsset: IRelatedAsset): RelatedAsset {
    return new RelatedAsset(relatedAsset);
  }

  /**
   * Navigate to the Dashboard of the related Asset
   */
  public async navigateToEntitySheet(): Promise<void> {
    if (!this.isSingleEntityControl(this.form.controls.field)) return;

    this.analyticsService.trackNavigationEvent(
      EventOriginEnum.FIELD_CLICK,
      NavigateToEnum.SHEET,
      EntityTypeEnum.ASSET,
      this.form.controls.field.value.id
    );
    await this.assetsService.navigateToAssetSheet(this.form.controls.field.value.id, 'dashboard');
  }
}
